<template>
  <ListItem>
    <template #media>
      <div class="list-item-branch-media m-rounded-icon">
        <img src="@/assets/slp-logo.svg" class="logo" alt="Pobočka">
      </div>
    </template>
    <BranchFragment
      :branch="branch"
    />
  </ListItem>
</template>

<script setup>
import ListItem from '@/components/ListItem.vue';
import BranchFragment from '@/components/BranchFragment.vue';

defineProps({
  branch: {
    type: Object,
    required: true,
  },
});
</script>

<style scoped>
.list-item-branch-media {
  background-color: var(--yellow);
  & .logo {
    width: 24px;
    height: 24px;
  }
}

</style>
